import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarMenu from '../sidebar/sidebar.jsx'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import { useParams } from 'react-router-dom';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import useRoomSocket from '../../clientServices/RoomSocket.js';
import './DoctorPage.css';
import { getAllRooms } from '../../clientServices/RoomService.js';
import { GetRoomQueue } from '../../clientServices/QueueService.js';
import EmergencyDoctorAlertModal from '../QueuesManagment/modals/EmergencyDoctorAlert.jsx';
import DeletePatientModal from '../QueuesManagment/modals/DeletePatient.jsx';
// import Role from '../Role/role.jsx';
import MorePatientOptions from './morePatientOptions.jsx';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AssistantIcon from '@mui/icons-material/Assistant';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import TurnRightIcon from '@mui/icons-material/TurnRight';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import DoneIcon from '@mui/icons-material/Done';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';



const DoctorPage = () => {



    const { id } = useParams();
    const [currentPatient, setCurrentPatient] = useState();
    const [nextPatient, setNextPatient] = useState();
    const [roomData, setRoomData] = useState({});
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State to manage the delete modal
    const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false); // State to manage the emergency modal
    const [roomButtons, setRoomButtons] = useState([]);
    const [queueAmount, setQueueAmount] = useState("");
    const [change, setChange] = useState(0);

    const { moveRoom, emergencyAlertToDoctor, endOfTreatment, alertComponent, callPatientBroadcast } = useRoomSocket(id, currentPatient, setCurrentPatient, nextPatient, setNextPatient, setChange, change);

    const navigate = useNavigate();
    // useEffect(() => {
    //     if (!localStorage.getItem('email')) {
    //         navigate('/');
    //     }
    // }, []);

    useEffect(() => {
        // שמירה של ה-ID של הדף ב-localStorage
        localStorage.setItem('lastVisitedDoctorPage', id);
    }, [id]);

    const location = useLocation();
    const role = location.state;

    const getIconForRoom = (roomId) => {
        switch (roomId) {
            case 1:
                return <AssistantIcon className='queueIcon' />;

            case 2:
                return <ZoomOutMapIcon className='queueIcon' />;

            case 3:
                return <MonitorHeartIcon className='queueIcon' />;

            case 4:
                return <VaccinesIcon className='queueIcon' />;

            case 5:
                return <TroubleshootIcon className='queueIcon' />;
            case 6:
                return <TurnRightIcon className='queueIcon' />;
            case 7:
                return <MeetingRoomIcon className='queueIcon' />;
            case 8:
                return <DeviceThermostatIcon className='queueIcon' />;
            default:
                return <DeviceThermostatIcon className='queueIcon' />;
        }
    };

    useEffect(() => {
        const fetchAllRooms = async () => {
            try {
                const response = await getAllRooms();
                const fetchedRooms = response.data;
                const roomData = fetchedRooms.find(room => room.ID === parseInt(id));
                setRoomData(roomData);
                console.log(roomData);

                const mappedRoomButtons = fetchedRooms.map((room, index) => ({
                    roomId: room.ID, // Using index as roomId
                    roomNmae : room.Name,
                    icon: getIconForRoom(index),
                    label: `העבר ל${room.Name}`
                }));

                setRoomButtons(mappedRoomButtons);
            } catch (error) {
                console.error('Error fetching rooms', error);
            }
        };

        fetchAllRooms();
    }, [id]);

    useEffect(() => {
        const fetchQueueAmount = async () => {
            try {
                const response = await GetRoomQueue(id);
                console.log(response.data); // הפונקציה לשלוף את מספר הממתינים

                // סינון המערך כך שיוצגו רק האובייקטים שבהם הערך של Tz אינו NULL
                const filteredData = response.data.filter(item => item.patient.UniqueNumber !== '');
                console.log("all wait patients", filteredData);
                console.log("wait patients count", filteredData.length);
                console.log("currentPatient:", currentPatient, "nextPatient:", nextPatient);

                const wait = filteredData.length;
                if (wait > 0 && currentPatient && currentPatient.UniqueNumber) {
                    setQueueAmount(wait - 1);
                    console.log("option 1");
                } else if (currentPatient && !nextPatient) {
                    setQueueAmount(0);
                    console.log("option 2");
                } else {
                    console.log("option 3");
                    setQueueAmount(wait);
                }
            } catch (error) {
                console.error('Error fetching queue amount:', error);
            }
        };

        fetchQueueAmount(); // קריאה לפונקציה בכל שינוי בנתונים
    }, [change, currentPatient, nextPatient]); // מעקב אחרי שינוי ב-currentPatient וב-nextPatient



    // Emergency Alert Handlers
    const handleConfirmEmergencyModal = () => {
        emergencyAlertToDoctor(currentPatient.UniqueNumber, roomData.ID);
        // alert('קריאת חירום נשלחה לרופא');
        handleCloseEmergencyModal();
    };

    const handleCloseEmergencyModal = () => {
        setIsEmergencyModalOpen(false);
    };

    const handleOpenEmergencyModal = () => {
        if (currentPatient && currentPatient.UniqueNumber && currentPatient.UniqueNumber !== '') {
            setIsEmergencyModalOpen(true);
        } else {
            alert("אין מטופל בחדר");
        }
    };


    // Finish Treatment Handlers
    const handleFinishTreatment = async () => {
        setIsDeleteModalOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const handleConfirmDeleteModal = async () => {
        try {
            if (currentPatient && currentPatient.UniqueNumber !== '') {
                endOfTreatment(currentPatient.ID);
            } else {
                alert('אין מטופל בחדר');
            }
            handleCloseDeleteModal();
        } catch (error) {
            console.error('Error deleting patient:', error);
            alert('Failed to delete patient.');
        }
    };


    const callToPatient = async () => {

        if (currentPatient) {
            console.log(roomData.ID, roomData.RoomNumber)
            callPatientBroadcast(currentPatient.UniqueNumber, roomData.RoomNumber, roomData.ID);
        } else {
            if (nextPatient)
                callPatientBroadcast("", roomData.RoomNumber, roomData.ID);
            else
                alert("אין ממתינים");
        }
    };




    const anotherButtons = [
        { roomId: 1, icon: <DoneIcon className='svgIcon' />, label: 'סיום טיפול', className: 'EndOfTreatment anotherButtons', onclick: handleFinishTreatment },
        { roomId: 2, icon: <PriorityHighIcon className='svgIcon' />, label: 'התראת חירום לרופא ', className: 'emergencyAlert anotherButtons', onclick: handleOpenEmergencyModal }
    ];

    return (
        <div className='doctorPageContainer'>
            {/* {(role === 2 || role === 1) && (<SidebarMenu role={role} />)} */}
            <SidebarMenu role={role} />

            <div className='receptionRoomCont'>
                <MorePatientOptions roomName={roomData.Name} />

                <div className='queuesCont'>
                    <div className='secondCont'>
                        <div className='qeueuCenter'>
                            <div className='queueDetails'>
                                <div className='roomTitle'>
                                    <div>חדר {roomData.Name}</div>
                                    {roomData.Name !== "קבלה" ? <div className='roomNumberTitle'>מספר {roomData.RoomNumber}</div>
                                        : <span></span>}

                                </div>



                                <div className='currentPatient'>

                                    {currentPatient && currentPatient.UniqueNumber ? (
                                        <>
                                            <div className='patientNumber'>{currentPatient.UniqueNumber}</div>
                                            <div className='patientName'>{currentPatient.tz}</div>
                                        </>
                                    ) : (
                                        <>
                                            <div className='noPatientMessage'>אין מטופל בחדר כרגע</div>
                                            {nextPatient && nextPatient.UniqueNumber ? (
                                                <button className='ApproveNextPatient' onClick={callToPatient}>
                                                    הכנס מטופל
                                                </button>
                                            ) : (
                                                <span></span>
                                            )}
                                        </>

                                    )}
                                </div>
                            </div>
                            <div className='nextPatient'>
                                {nextPatient && nextPatient.UniqueNumber ? (
                                    <>
                                        <span className='queueDetTitle'>מטופל הבא </span>
                                        <div className='nextPatientNumber'>{nextPatient.UniqueNumber}</div>
                                    </>
                                ) : (
                                    <div className='noNextPatientMessage'>אין ממתינים</div>
                                )}

                            </div>
                        </div>


                        <div className='allBtnsCont'>

                            <div className='anotherBtnsCont'>
                                {anotherButtons.map((button1, index) => (
                                    button1.Id !== parseInt(id) && (
                                        <button key={index} className={button1.className} onClick={button1.onclick}>
                                            {button1.icon}
                                        </button>
                                    )
                                ))}
                            </div>



                            <div className='queuesList'>
                                {roomButtons.map((button, index) => (
                                    button.roomId !== parseInt(id) && (
                                        // Check if the current room is not 'קבלה'
                                        button.roomNmae !== 'רופא' || (button.roomNmae === 'רופא' && roomData.Name !== 'קבלה')
                                    ) && (
                                        <button key={index} onClick={() => moveRoom(button.roomId)} className='moveQueue'>
                                            <div className='moveCont'>
                                                {button.icon}
                                                <div style={{ marginRight: "5px" }}>{button.label}</div>
                                            </div>
                                        </button>
                                    )
                                ))}
                            </div>


                        </div>
                    </div>
                    <button onClick={callToPatient} className='callToPatient'>
                        קריאה למטופל
                        <VolumeUpIcon />
                    </button>

                    <div className='numOfWaitPatientsContainerRooms'>
                        <div className='numOfWaitPatientsRooms'>{queueAmount}</div>
                        <div>מספר ממתינים</div>
                    </div>
                </div>


            </div>

            <DeletePatientModal
                open={isDeleteModalOpen}
                handleClose={handleCloseDeleteModal}
                handleConfirm={handleConfirmDeleteModal}
                patientName={currentPatient ? `${currentPatient.UniqueNumber}` : ''}
            />

            <EmergencyDoctorAlertModal
                open={isEmergencyModalOpen}
                handleClose={handleCloseEmergencyModal}
                handleConfirm={handleConfirmEmergencyModal}
                patientName={currentPatient ? `${currentPatient.UniqueNumber}` : ''}
                roomName={id ? roomData.Name : ''}
            />
            {alertComponent} {/* This renders the custom alert */}
            <div className='roleContainer'>
                {/* <Role /> */}
            </div>
        </div >
    );
};

export default DoctorPage;
